/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Col } from "react-awesome-styled-grid";
import { When } from "react-if";
import { Text, theme, FlexContainer } from "@nordcloud/gnui";
import { StyledRect } from "~/components";

type TableRowsProps = {
  showForecast: boolean;
  show: boolean;
};

export function TableRows({ showForecast, show }: TableRowsProps) {
  if (!show) {
    return <></>;
  }
  return (
    <Col>
      <FlexContainer direction="row" alignItems="center" justifyContent="left">
        <Text
          size="sm"
          tag="span"
          color={theme.color.text.text02}
          lineHeight="1.2rem"
        >
          Provider
        </Text>
        <StyledRect style={{ background: "transparent" }} />
      </FlexContainer>
      <Text
        size="sm"
        tag="span"
        color={theme.color.text.text02}
        lineHeight="1.2rem"
      >
        Cost
      </Text>
      <When condition={showForecast}>
        <Text
          size="xs"
          tag="span"
          color={theme.color.text.text02}
          lineHeight="1.2rem"
        >
          Forecast
        </Text>
      </When>
    </Col>
  );
}
